import { useEffect, useState } from 'react';
import { isTicketSelectionExcludedInListings } from '../components/EventDetails/ConversionBarContainer/isTicketSelectionExcludedInListings';
import { useEventBasicInformationContext, useTicketContext } from '../contexts';
import { useFeatureFlag } from '../contexts/FeatureFlags/FeatureFlagsContext';
import { normalizeDisqualificationKeys } from '../contexts/TicketContext/helpers';
import { LISTINGS_CONDENSED_CHECKOUT_EXPERIMENT } from './constants';
import { genericGetBooleanExperiment } from './experiments';

export const useCondensedCheckoutExperiment = () => {
    const [experimentValue, setExperimentValue] = useState<boolean>(false);
    const {
        ticketData: { compactCheckoutDisqualifications },
        externalTicketsAreAvailable = false,
    } = useTicketContext();
    const shouldShowOnlyDefaultCheckoutOnlineEvents = useFeatureFlag<boolean>(
        'shouldShowOnlyDefaultCheckoutOnlineEvents',
    );
    const {
        place: { isOnline },
        salesStatus,
        isRepeating,
    } = useEventBasicInformationContext();

    useEffect(() => {
        const onlyDefaultCheckoutForOnlineEvents =
            isOnline && shouldShowOnlyDefaultCheckoutOnlineEvents;

        if (
            isRepeating ||
            isTicketSelectionExcludedInListings({
                ...normalizeDisqualificationKeys(
                    compactCheckoutDisqualifications,
                ),
                externalTicketsAreAvailable,
                salesStatus,
                onlyDefaultCheckoutForOnlineEvents:
                    onlyDefaultCheckoutForOnlineEvents || false,
            })
        ) {
            return;
        }

        const experiment = genericGetBooleanExperiment(
            LISTINGS_CONDENSED_CHECKOUT_EXPERIMENT,
        );
        setExperimentValue(experiment);
    }, [
        compactCheckoutDisqualifications,
        externalTicketsAreAvailable,
        salesStatus,
        shouldShowOnlyDefaultCheckoutOnlineEvents,
        isOnline,
        setExperimentValue,
        isRepeating,
    ]);

    return experimentValue;
};
